import { strollersPrefix, strollersUrl } from 'mk2/apps/strollers/urls';
import { getWikiArticleState } from 'mk2/apps/wiki/containers/Article/Article.selectors';
import ArticlePage, { DispatchProps, OwnProps, StateProps } from 'mk2/apps/wiki/containers/Article/ArticlePage';
import {
    getRequestBaseUrl,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
    AppState,
} from 'mk2/reducers';
import {
    ArticleLinkDataEntity,
    ArticleLinkDataSchema, EshopProductEntity, EshopProductSchema,
    WikiArticleEntity,
    WikiArticleSchema,
} from 'mk2/schemas';
import { getDenormalizedEntities, getDenormalizedEntitiesMapList, getDenormalizedEntity } from 'mk2/selectors';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

export type RouteProps = RouteComponentProps<{
    articleSlug: string;
}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class WikiArticlePage extends ArticlePage {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const experienceIdRef = ownProps.location.hash;
            const articleSlug = ownProps.match.params.articleSlug;
            const categorySlug = strollersPrefix;
            const articleState = getWikiArticleState(state, categorySlug, articleSlug);
            const viewsCountTotal = articleState.viewsCountTotal;
            const viewsCountUnique = articleState.viewsCountUnique;

            const article: WikiArticleEntity = getDenormalizedEntity<WikiArticleEntity>(
                state,
                WikiArticleSchema,
                articleState.articleId,
            );

            const relatedArticles: ArticleLinkDataEntity[] = getDenormalizedEntities<ArticleLinkDataEntity>(
                state,
                ArticleLinkDataSchema,
                articleState.relatedArticles,
            );

            const eshopProductsOfEshopNodes = getDenormalizedEntitiesMapList<EshopProductEntity>(
                state,
                EshopProductSchema,
                articleState.eshopProductsOfEshopNodes,
            );

            return {
                article,
                viewsCountTotal,
                viewsCountUnique,
                articleConceptPath: articleState.articleConceptPath,
                relatedArticles,
                reviewCategoryArticlesCount: null,
                reviewCategoryArticles: null,
                reviewCategoryExperiences: null,
                reviewCategories: null,
                reviewCategoriesStats: null,
                experienceIdRef,
                isMobile: getRequestDeviceMobile(state),
                requestUser: getRequestUser(state),
                requestUserPermissions: getRequestPermissions(state),
                loadingState: articleState.loadingState,
                baseUrl: getRequestBaseUrl(state),
                errorMessage: articleState.errorMessage,
                articleSlug,
                categorySlug,
                moreReviewCategoryArticlesLoadingState: articleState.moreReviewCategoryArticlesLoadingState,
                similarPosts: null,
                eshopProductsOfEshopNodes,
            };
        };
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return strollersUrl;
    }
}
